(function () {
    'use strict';
    /**
     * @memberof appback
     *@ngdoc service
     *@name SelloutService
     *@description
     *Sell-out de distribuidores (backend\controllers\SelloutController)
     */

    angular
        .module('appback')
        .factory('SelloutService', SelloutService);

    SelloutService.$inject = ["$http", "$q"];

    function SelloutService($http, $q) {

        var sellout = {
            GetCartera: GetCartera,
            GetInforme: GetInforme,
        };

        function datos(response) {
            if (!response.data || !response.data.success || !response.data.data) {
                return $q.reject(response.data);
            }

            return response.data.data;
        }

        function GetCartera(paisId) {
            return $http.get('/backend/sellout/getcartera', {
                params: {
                    pais_id: paisId || ''
                }
            }).then(datos);
        }

        function GetInforme(id) {
            return $http.get('/backend/sellout/getinforme', {
                params: {
                    id: id
                }
            }).then(datos);
        }

        return sellout;
    }
})();
